import React from 'react';
import colors from '../../utils/colors';
import { KaraokeIcon } from './AudioPlayerIcons';

// Icons for the remix submenu
const EditorIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M4 13.3333C3.81111 13.3333 3.65278 13.2694 3.525 13.1416C3.39722 13.0138 3.33333 12.8555 3.33333 12.6666V8.66663H2.66667C2.47778 8.66663 2.31944 8.60274 2.19167 8.47496C2.06389 8.34718 2 8.18885 2 7.99996C2 7.81107 2.06389 7.65274 2.19167 7.52496C2.31944 7.39718 2.47778 7.33329 2.66667 7.33329H5.33333C5.52222 7.33329 5.68056 7.39718 5.80833 7.52496C5.93611 7.65274 6 7.81107 6 7.99996C6 8.18885 5.93611 8.34718 5.80833 8.47496C5.68056 8.60274 5.52222 8.66663 5.33333 8.66663H4.66667V12.6666C4.66667 12.8555 4.60278 13.0138 4.475 13.1416C4.34722 13.2694 4.18889 13.3333 4 13.3333ZM4 5.99996C3.81111 5.99996 3.65278 5.93607 3.525 5.80829C3.39722 5.68051 3.33333 5.52218 3.33333 5.33329V3.33329C3.33333 3.1444 3.39722 2.98607 3.525 2.85829C3.65278 2.73051 3.81111 2.66663 4 2.66663C4.18889 2.66663 4.34722 2.73051 4.475 2.85829C4.60278 2.98607 4.66667 3.1444 4.66667 3.33329V5.33329C4.66667 5.52218 4.60278 5.68051 4.475 5.80829C4.34722 5.93607 4.18889 5.99996 4 5.99996ZM6.66667 5.99996C6.47778 5.99996 6.31944 5.93607 6.19167 5.80829C6.06389 5.68051 6 5.52218 6 5.33329C6 5.1444 6.06389 4.98607 6.19167 4.85829C6.31944 4.73051 6.47778 4.66663 6.66667 4.66663H7.33333V3.33329C7.33333 3.1444 7.39722 2.98607 7.525 2.85829C7.65278 2.73051 7.81111 2.66663 8 2.66663C8.18889 2.66663 8.34722 2.73051 8.475 2.85829C8.60278 2.98607 8.66667 3.1444 8.66667 3.33329V4.66663H9.33333C9.52222 4.66663 9.68056 4.73051 9.80833 4.85829C9.93611 4.98607 10 5.1444 10 5.33329C10 5.52218 9.93611 5.68051 9.80833 5.80829C9.68056 5.93607 9.52222 5.99996 9.33333 5.99996H6.66667ZM8 13.3333C7.81111 13.3333 7.65278 13.2694 7.525 13.1416C7.39722 13.0138 7.33333 12.8555 7.33333 12.6666V7.99996C7.33333 7.81107 7.39722 7.65274 7.525 7.52496C7.65278 7.39718 7.81111 7.33329 8 7.33329C8.18889 7.33329 8.34722 7.39718 8.475 7.52496C8.60278 7.65274 8.66667 7.81107 8.66667 7.99996V12.6666C8.66667 12.8555 8.60278 13.0138 8.475 13.1416C8.34722 13.2694 8.18889 13.3333 8 13.3333ZM12 13.3333C11.8111 13.3333 11.6528 13.2694 11.525 13.1416C11.3972 13.0138 11.3333 12.8555 11.3333 12.6666V11.3333H10.6667C10.4778 11.3333 10.3194 11.2694 10.1917 11.1416C10.0639 11.0138 10 10.8555 10 10.6666C10 10.4777 10.0639 10.3194 10.1917 10.1916C10.3194 10.0638 10.4778 9.99996 10.6667 9.99996H13.3333C13.5222 9.99996 13.6806 10.0638 13.8083 10.1916C13.9361 10.3194 14 10.4777 14 10.6666C14 10.8555 13.9361 11.0138 13.8083 11.1416C13.6806 11.2694 13.5222 11.3333 13.3333 11.3333H12.6667V12.6666C12.6667 12.8555 12.6028 13.0138 12.475 13.1416C12.3472 13.2694 12.1889 13.3333 12 13.3333ZM12 8.66663C11.8111 8.66663 11.6528 8.60274 11.525 8.47496C11.3972 8.34718 11.3333 8.18885 11.3333 7.99996V3.33329C11.3333 3.1444 11.3972 2.98607 11.525 2.85829C11.6528 2.73051 11.8111 2.66663 12 2.66663C12.1889 2.66663 12.3472 2.73051 12.475 2.85829C12.6028 2.98607 12.6667 3.1444 12.6667 3.33329V7.99996C12.6667 8.18885 12.6028 8.34718 12.475 8.47496C12.3472 8.60274 12.1889 8.66663 12 8.66663Z"
      fill="#FAF7F5"
    />
  </svg>
);

const RefreshIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M1.83091 5.8812C2.71458 3.07424 5.42504 1.13418 8.48696 1.3497L8.48764 1.34975C10.6279 1.50263 12.4467 2.66631 13.5168 4.3413L13.6148 4.04929C13.732 3.70025 14.1099 3.51227 14.459 3.62944C14.808 3.74662 14.996 4.12456 14.8788 4.47361L14.2455 6.36028C14.1283 6.70933 13.7504 6.8973 13.4013 6.78013L11.5147 6.14679C11.1656 6.02962 10.9776 5.65168 11.0948 5.30263C11.212 4.95358 11.5899 4.76561 11.939 4.88278L12.3739 5.02876C11.5199 3.71175 10.0821 2.80047 8.39297 2.67972C5.9617 2.50875 3.80567 4.04865 3.10271 6.28158C2.99215 6.63278 2.61782 6.82785 2.26662 6.71729C1.91542 6.60673 1.72035 6.2324 1.83091 5.8812Z"
      fill="#FAF7F5"
    />
    <path
      d="M9.4135 8.01474C9.4135 8.81739 8.76282 9.46807 7.96017 9.46807C7.15752 9.46807 6.50684 8.81739 6.50684 8.01474C6.50684 7.21208 7.15752 6.5614 7.96017 6.5614C8.76282 6.5614 9.4135 7.21208 9.4135 8.01474Z"
      fill="#FAF7F5"
    />
    <path
      d="M13.6537 9.31883C14.0049 9.42939 14.2 9.80372 14.0894 10.1549C13.2055 12.9627 10.4878 14.9019 7.42672 14.6864L7.42603 14.6864C5.28575 14.5335 3.46695 13.3698 2.3969 11.6948L2.29886 11.9869C2.18168 12.336 1.80374 12.5239 1.45469 12.4068C1.10564 12.2896 0.917669 11.9116 1.03484 11.5626L1.66817 9.67592C1.78535 9.32687 2.16329 9.1389 2.51234 9.25607L4.39901 9.88941C4.74805 10.0066 4.93603 10.3845 4.81886 10.7336C4.70168 11.0826 4.32374 11.2706 3.97469 11.1534L3.53988 11.0075C4.39387 12.3244 5.83168 13.2357 7.52082 13.3564C9.95288 13.5274 12.1149 11.9866 12.8176 9.75454C12.9282 9.40334 13.3025 9.20827 13.6537 9.31883Z"
      fill="#FAF7F5"
    />
  </svg>
);

const ArrowRightIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M12.1168 7.33334L6.00016 7.33334C5.81127 7.33334 5.65294 7.39723 5.52516 7.52501C5.39738 7.65279 5.3335 7.81112 5.3335 8.00001C5.3335 8.1889 5.39738 8.34723 5.52516 8.47501C5.65294 8.60279 5.81127 8.66667 6.00016 8.66667H12.1168L10.2002 10.6C10.0779 10.7222 10.0141 10.875 10.0085 11.0583C10.0029 11.2417 10.0668 11.4 10.2002 11.5333C10.3224 11.6556 10.4779 11.7167 10.6668 11.7167C10.8557 11.7167 11.0113 11.6556 11.1335 11.5333L14.2002 8.46667C14.2668 8.40001 14.3141 8.32779 14.3418 8.25001C14.3696 8.17223 14.3835 8.0889 14.3835 8.00001C14.3835 7.91112 14.3696 7.82779 14.3418 7.75001C14.3141 7.67223 14.2668 7.60001 14.2002 7.53334L11.1335 4.46667C11.0113 4.34445 10.8585 4.28334 10.6752 4.28334C10.4918 4.28334 10.3335 4.34445 10.2002 4.46667C10.0668 4.60001 10.0002 4.75834 10.0002 4.94167C10.0002 5.12501 10.0668 5.28334 10.2002 5.41667L12.1168 7.33334Z"
      fill="#FAF7F5"
    />
    <path
      d="M2.66667 12C2.47778 12 2.31944 11.9361 2.19167 11.8083C2.06389 11.6806 2 11.5222 2 11.3333V4.66667C2 4.47778 2.06389 4.31944 2.19167 4.19167C2.31944 4.06389 2.47778 4 2.66667 4C2.85556 4 3.01389 4.06389 3.14167 4.19167C3.26944 4.31944 3.33333 4.47778 3.33333 4.66667V11.3333C3.33333 11.5222 3.26944 11.6806 3.14167 11.8083C3.01389 11.9361 2.85556 12 2.66667 12Z"
      fill="#FAF7F5"
    />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M3.88317 8.66666H9.99984C10.1887 8.66666 10.3471 8.60277 10.4748 8.47499C10.6026 8.34721 10.6665 8.18888 10.6665 7.99999C10.6665 7.8111 10.6026 7.65277 10.4748 7.52499C10.3471 7.39721 10.1887 7.33333 9.99984 7.33333H3.88317L5.79984 5.39999C5.92206 5.27777 5.98595 5.12499 5.9915 4.94166C5.99706 4.75833 5.93317 4.59999 5.79984 4.46666C5.67761 4.34444 5.52206 4.28333 5.33317 4.28333C5.14428 4.28333 4.98873 4.34444 4.8665 4.46666L1.79984 7.53333C1.73317 7.59999 1.68595 7.67221 1.65817 7.74999C1.63039 7.82777 1.6165 7.9111 1.6165 7.99999C1.6165 8.08888 1.63039 8.17221 1.65817 8.24999C1.68595 8.32777 1.73317 8.39999 1.79984 8.46666L4.8665 11.5333C4.98873 11.6555 5.1415 11.7167 5.32484 11.7167C5.50817 11.7167 5.6665 11.6555 5.79984 11.5333C5.93317 11.4 5.99984 11.2417 5.99984 11.0583C5.99984 10.875 5.93317 10.7167 5.79984 10.5833L3.88317 8.66666Z"
      fill="#FAF7F5"
    />
    <path
      d="M13.3332 12C13.1443 12 12.9859 11.9361 12.8582 11.8083C12.7304 11.6806 12.6665 11.5222 12.6665 11.3333V4.66667C12.6665 4.47778 12.7304 4.31944 12.8582 4.19167C12.9859 4.06389 13.1443 4 13.3332 4C13.5221 4 13.6804 4.06389 13.8082 4.19167C13.9359 4.31944 13.9998 4.47778 13.9998 4.66667V11.3333C13.9998 11.5222 13.9359 11.6806 13.8082 11.8083C13.6804 11.9361 13.5221 12 13.3332 12Z"
      fill="#FAF7F5"
    />
  </svg>
);

const SpeedIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M8.00016 1.33337C11.6764 1.33337 14.6668 4.32381 14.6668 8.00004C14.6668 11.6763 11.6764 14.6667 8.00016 14.6667C7.57063 14.6667 7.22449 14.3206 7.22449 13.891C7.22449 13.4615 7.57063 13.1154 8.00016 13.1154C10.8208 13.1154 13.1155 10.8207 13.1155 8.00004C13.1155 5.17937 10.8208 2.88472 8.00016 2.88472C5.17949 2.88472 2.88484 5.17937 2.88484 8.00004C2.88484 8.42957 2.5387 8.77571 2.10917 8.77572C1.67964 8.77572 1.3335 8.42957 1.3335 8.00004C1.3335 4.32381 4.32393 1.33337 8.00016 1.33337Z"
      fill="#FAF7F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.63249 4.92116C9.93612 4.67413 10.3859 4.69182 10.6686 4.97436C10.9511 5.25704 10.9688 5.70683 10.7218 6.01044L10.6686 6.06919L9.48641 7.25057C9.5496 7.42039 9.58878 7.60546 9.58883 7.79997V7.80394C9.58875 8.68158 8.87777 9.39159 8.00016 9.39181C7.12254 9.39162 6.41237 8.68159 6.41229 7.80394C6.41229 6.92622 7.12249 6.21626 8.00016 6.21607C8.10523 6.21611 8.20445 6.23108 8.29709 6.25021L9.57374 4.97436L9.63249 4.92116ZM6.59966 8.07388C6.60063 8.07893 6.60182 8.08393 6.60284 8.08896C6.59362 8.04343 6.58697 7.99703 6.5822 7.95002L6.59966 8.07388ZM9.42528 7.79997V7.80394C9.42527 7.89933 9.41611 7.9925 9.39828 8.08261C9.4069 8.03907 9.41437 7.9949 9.41892 7.95002L9.42528 7.80394V7.79997ZM9.29586 7.21166C9.33615 7.30099 9.36881 7.39578 9.39114 7.4943L9.35065 7.34901C9.33478 7.30204 9.31593 7.25617 9.29586 7.21166ZM7.32453 6.54794C7.24204 6.59233 7.16434 6.64438 7.0927 6.70355L7.20305 6.62177C7.24224 6.59531 7.28269 6.57049 7.32453 6.54794ZM8.00016 6.37803C8.1227 6.37804 8.23825 6.39925 8.35029 6.42726L8.17959 6.39232C8.15069 6.38798 8.12107 6.38441 8.09147 6.382L8.00016 6.37803Z"
      fill="#FAF7F5"
    />
  </svg>
);

const ReplaceIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="none"
  >
    <path
      d="M0.884342 13.24C0.457676 13.24 0.117676 12.8934 0.117676 12.4734V4.10004C0.117676 3.67337 0.457676 3.33337 0.884342 3.33337C1.31101 3.33337 1.65101 3.67337 1.65101 4.10004V12.4734C1.65101 12.8934 1.31101 13.24 0.884342 13.24Z"
      fill="#FAF7F5"
    />
    <path
      d="M12.851 5.06005C12.851 4.68672 12.551 4.38672 12.1777 4.38672H3.81101C3.43767 4.38672 3.13768 4.68672 3.13768 5.06005V11.5134C3.13768 11.8867 3.43767 12.1867 3.81101 12.1867H12.1777C12.551 12.1867 12.851 11.8867 12.851 11.5134V5.06005Z"
      fill="#FAF7F5"
    />
    <path
      d="M14.3377 12.4734C14.3377 12.8934 14.6843 13.24 15.1043 13.24C15.5243 13.24 15.871 12.8934 15.871 12.4734V4.10004C15.871 3.67337 15.5243 3.33337 15.1043 3.33337C14.6843 3.33337 14.3377 3.67337 14.3377 4.10004V12.4734Z"
      fill="#FAF7F5"
    />
  </svg>
);

const LyricsIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M9.77778 13.3333C9.10556 13.3333 8.53009 13.1012 8.05139 12.637C7.57269 12.1728 7.33333 11.6148 7.33333 10.9629C7.33333 10.3111 7.57269 9.75305 8.05139 9.28885C8.53009 8.82465 9.10556 8.59255 9.77778 8.59255C10.012 8.59255 10.2285 8.61971 10.4271 8.67403C10.6257 8.72835 10.8167 8.80984 11 8.91848V3.25922C11 3.09132 11.0586 2.95058 11.1757 2.837C11.2928 2.72342 11.438 2.66663 11.6111 2.66663H14.0556C14.2287 2.66663 14.3738 2.72342 14.491 2.837C14.6081 2.95058 14.6667 3.09132 14.6667 3.25922V4.4444C14.6667 4.6123 14.6081 4.75305 14.491 4.86663C14.3738 4.98021 14.2287 5.037 14.0556 5.037H12.2222V10.9629C12.2222 11.6148 11.9829 12.1728 11.5042 12.637C11.0255 13.1012 10.45 13.3333 9.77778 13.3333Z"
      fill="#FAF7F5"
    />
    <path
      d="M2 3.99996C2 3.63177 2.29848 3.33329 2.66667 3.33329H7.33333C7.70152 3.33329 8 3.63177 8 3.99996C8 4.36815 7.70152 4.66663 7.33333 4.66663H2.66667C2.29848 4.66663 2 4.36815 2 3.99996Z"
      fill="#FAF7F5"
    />
    <path
      d="M2.66667 5.99996C2.29848 5.99996 2 6.29844 2 6.66663C2 7.03482 2.29848 7.33329 2.66667 7.33329H8C8.36819 7.33329 8.66667 7.03482 8.66667 6.66663C8.66667 6.29844 8.36819 5.99996 8 5.99996H2.66667Z"
      fill="#FAF7F5"
    />
    <path
      d="M2 9.33329C2 8.9651 2.29848 8.66663 2.66667 8.66663H6C6.36819 8.66663 6.66667 8.9651 6.66667 9.33329C6.66667 9.70148 6.36819 9.99996 6 9.99996H2.66667C2.29848 9.99996 2 9.70148 2 9.33329Z"
      fill="#FAF7F5"
    />
    <path
      d="M2.66667 11.3333C2.29848 11.3333 2 11.6318 2 12C2 12.3681 2.29848 12.6666 2.66667 12.6666H4.66667C5.03486 12.6666 5.33333 12.3681 5.33333 12C5.33333 11.6318 5.03486 11.3333 4.66667 11.3333H2.66667Z"
      fill="#FAF7F5"
    />
  </svg>
);

const RemixSubmenu = ({ 
  onOpenEditor,
  onCover,
  onKaraoke,
  onExtend,
  onIntro,
  onSpeed,
  onReplaceSection,
  onReuseLyrics,
  onClose,
  className = ""
}) => {
  const menuItems = [
    {
      icon: EditorIcon,
      label: "Open in Editor",
      onClick: onOpenEditor,
      standalone: true
    },
    {
      icon: RefreshIcon,
      label: "Cover",
      onClick: onCover
    },
    {
      icon: KaraokeIcon,
      label: "Karaoke",
      onClick: onKaraoke
    },
    {
      icon: ArrowRightIcon,
      label: "Extend",
      onClick: onExtend
    },
    {
      icon: ArrowLeftIcon,
      label: "Intro",
      onClick: onIntro
    },
    {
      icon: SpeedIcon,
      label: "Speed",
      onClick: onSpeed
    },
    {
      icon: ReplaceIcon,
      label: "Replace Section",
      onClick: onReplaceSection
    },
    {
      icon: LyricsIcon,
      label: "Reuse Lyrics",
      onClick: onReuseLyrics
    }
  ];

  return (
    <div
      className={`flex flex-col justify-start items-start w-[180px] overflow-hidden rounded-lg ${className}`}
      style={{ backgroundColor: colors.bg.tertiary, boxShadow: "0px 1px 16px 0 rgba(0,0,0,0.4)" }}
    >
      {/* Open in Editor - Standalone item with border bottom */}
      <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 overflow-hidden border-b border-white/10">
        <div 
          className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 h-10 relative overflow-hidden gap-[9px] px-3 py-[13px] cursor-pointer transition-colors hover:bg-white/[0.04]"
          style={{ backgroundColor: colors.bg.tertiary }}
          onClick={() => {
            onOpenEditor?.();
            onClose?.();
          }}
        >
          <EditorIcon />
          <div className="flex justify-start items-end flex-grow-0 flex-shrink-0 relative gap-2">
            <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-left text-white">
              Open in Editor
            </p>
          </div>
        </div>
      </div>

      {/* Other remix options - no padding between sections */}
      <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 overflow-hidden">
        {menuItems.slice(1).map((item, index) => {
          const IconComponent = item.icon;
          return (
            <div 
              key={index}
              className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 h-10 relative overflow-hidden gap-[9px] px-3 py-[13px] cursor-pointer transition-colors hover:bg-white/[0.04]"
              style={{ backgroundColor: colors.bg.tertiary }}
              onClick={() => {
                item.onClick?.();
                onClose?.();
              }}
            >
              <IconComponent />
              <div className="flex justify-start items-end flex-grow-0 flex-shrink-0 relative gap-2">
                <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-left text-white">
                  {item.label}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RemixSubmenu;